import { i18nTime, useI18n } from '@affine/i18n';
import dayjs from 'dayjs';

import * as styles from './styles.css';

export const BlocksuiteEditorJournalDocTitle = ({
  date: dateStr,
  overrideClassName,
}: {
  date?: string;
  overrideClassName?: string;
}) => {
  const t = useI18n();

  const localizedJournalDate = i18nTime(dateStr, {
    absolute: { accuracy: 'day' },
  });

  const today = dayjs();
  const date = dayjs(dateStr);
  const day = dayjs(date).day() ?? null;
  const weekDays = [
    t['com.affine.calendar.weekdays.sun'](),
    t['com.affine.calendar.weekdays.mon'](),
    t['com.affine.calendar.weekdays.tue'](),
    t['com.affine.calendar.weekdays.wed'](),
    t['com.affine.calendar.weekdays.thu'](),
    t['com.affine.calendar.weekdays.fri'](),
    t['com.affine.calendar.weekdays.sat'](),
  ];

  const isToday = date.isSame(today, 'day');

  return (
    <span className={overrideClassName ?? 'doc-title-container'}>
      <span>{localizedJournalDate}</span>
      {isToday ? (
        <span className={styles.titleTodayTag}>{t['com.affine.today']()}</span>
      ) : (
        day !== null && (
          <span className={styles.titleDayTag}>{weekDays[day]}</span>
        )
      )}
    </span>
  );
};
